// extracted by mini-css-extract-plugin
export var barContainer = "_55-0";
export var extraThin = "_55-3";
export var fillBar = "_55-6";
export var fillContainer = "_55-4";
export var overflow = "_55-8";
export var overflowContainer = "_55-5";
export var regular = "_55-7";
export var thick = "_55-1";
export var thin = "_55-2";